import { useState, useEffect } from "react";
import { BASE_URL } from "../constants";

const useClients = (lawyerId) => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!lawyerId) return;

    const fetchClients = async () => {
      setLoading(true);
      setError("");

      try {
        const response = await fetch(
          `${BASE_URL}/api/clients/lawyer/${lawyerId}`
        );
        const text = await response.text();
        let data;

        try {
          data = JSON.parse(text);
        } catch (err) {
          console.error("Invalid JSON from server:", text);
          setError("Invalid JSON from server");
          setClients([]);
          return;
        }

        if (!response.ok) {
          console.error("Server returned error:", data);
          setError(data.error || "Server returned error");
          setClients([]);
          return;
        }

        console.log("Fetched clients:", data.clients);
        setClients(data.clients || []);
      } catch (err) {
        console.error("Fetch error:", err);
        setError("Fetch error");
        setClients([]);
      } finally {
        setLoading(false);
      }
    };

    fetchClients();
  }, [lawyerId]);

  return { clients, loading, error };
};

export default useClients;
